<template>
  <div class="navBox">
    <!-- 图片：用 img 代替背景图，效果一模一样 -->
    <img class="navBox-bg" :src="headerImg" alt="背景" />

    <!-- 半透明遮罩 -->
    <div class="navBox-mask"></div>

    <div class="navBox-content">
      <p class="navBox-title">{{ headerTitle }}</p>
      <p class="navBox-desc">{{ headerDesc }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavBox',
  props: {
    headerTitle: String,
    headerDesc: String,
    headerImg: [String, Object], // 兼容 require
  },
};
</script>

<style scoped lang="less">
.navBox {
  width: 100%;
  height: 360px;
  position: relative; /* 改为 relative，方便层叠 */
  overflow: hidden;
}

/* 图片样式：和背景图效果完全一致 */
.navBox-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* 关键：等同于 background-size: cover */
  object-position: center; /* 等同于 background-position: center */
  z-index: 1;
}

.navBox-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 2;
}

.navBox-content {
  position: relative;
  z-index: 3;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;

  .navBox-title {
    font-size: 24px;
    color: #ffee00;
    margin-bottom: 16px;
  }

  .navBox-desc {
    font-size: 14px;
    color: #fff;
  }
}
</style>